/**
 *
 * ServiceRequestsManagerDxGrid
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import AdvancedDataTable from 'containers/AdvancedDataTable';
import { columnType, columnSize, requestColumnSizes } from 'domain/typeConstants/table';
import { settings } from 'containers/AdvancedDataTable/dxGridTypes';
import {
  ACTIVE_REQUESTS, REQUESTS_SERVICE_AND_WORK_PRODUCTION, MANAGER_REQUESTS
} from 'domain/Data/Filters/constants';

import {
  addActionButton,
  copyActionButton,
  editActionButton,
  acceptActionButton,
  rejectActionButton,
  completeActionButton,
} from '../common/actionButton';
import {
  viewActionItem,
  copyActionItem,
  editActionItem,
  acceptActionItem,
  rejectActionItem,
  completeActionItem,
} from '../common/actionMenu';
import { columnStatusLabels } from '../common/columnStatusLabel';

import { SERVICE_REQUESTS_MANAGER_REQUESTS_TABLE_GRID } from './constants';
import { role } from 'domain/typeConstants/roles';
import { getRequestDetailContainer } from 'pages/common/detailContainers';


class ServiceRequestsManagerDxGrid extends React.PureComponent { // eslint-disable-line react/prefer-stateless-function
  getFilters() {
    const { viewName } = this.props; // eslint-disable-line
    const filters = [REQUESTS_SERVICE_AND_WORK_PRODUCTION];
    if (viewName === 'active') filters.push(ACTIVE_REQUESTS);
    if (viewName === 'manager') filters.push(MANAGER_REQUESTS);
    return filters;
  }

  getColumns() {
    const blackListStyle = {
      style: { color: '#d50000' },
      condition: (value) => value.isBlackList,
    };
    const styles = [blackListStyle];

    return [
      {
        path: 'number',
        name: 'number',
        title: '№',
        type: columnType.NUMERIC,
        width: columnSize.NUMERIC,
        styles,
      },
      {
        path: 'actualCreationDate',
        name: 'actualCreationDate',
        title: 'Добавлено',
        type: columnType.DATETIME,
        width: columnSize.DATE,
      },
      {
        path: 'requestChangeDate',
        name: 'requestChangeDate',
        title: 'Изменено',
        type: columnType.DATETIME,
        width: columnSize.DATE,
        styles,
      },
      {
        path: ['company', 'name'],
        name: 'companyName',
        getCellValue: (row) => (row.company ? row.company.name : undefined),
        title: 'Арендатор',
        width: requestColumnSizes.companyName,
        styles,
      },
      {
        path: ['status', 'name'],
        name: 'statusName',
        getCellValue: (row) => (row.status ? row.status.name : undefined),
        title: 'Статус',
        type: columnType.LABEL,
        labels: columnStatusLabels,
        entityName: 'requestStatuses',
        width: requestColumnSizes.statusName,
      },
      {
        path: ['service', 'name'],
        name: 'serviceName',
        getCellValue: (row) => (row.service ? row.service.name : undefined),
        title: 'Сервис',
        entityName: 'requestTypes',
        width: requestColumnSizes.serviceName,
        styles,
      },
      {
        path: 'whereHappened',
        name: 'whereHappened',
        title: 'Где',
        width: requestColumnSizes.whereHappened,
      },

      {
        path: 'whatHappened',
        name: 'whatHappened',
        title: 'Что сделать',
        type: columnType.TEXT,
        width: requestColumnSizes.whatHappened,
      },
      {
        path: ['assignee', 'name'],
        name: 'assigneeName',
        getCellValue: (row) => (row.assignee ? row.assignee.name : undefined),
        title: 'Исполнитель',
        width: requestColumnSizes.assigneeName,
      },
      {
        path: 'executionTerm',
        name: 'executionTerm',
        title: 'Срок исполнения',
        type: columnType.DATE,
        width: columnSize.DATE,
      },
      {
        path: 'executionDate',
        name: 'executionDate',
        title: 'Исполнение факт',
        type: columnType.DATE,
        width: columnSize.DATE,
      },
      {
        path: ['file', 'name'],
        name: 'fileName',
        getCellValue: (row) => (row.file ? row.file.id : undefined),
        title: 'Файл',
        type: columnType.FILE,
        width: requestColumnSizes.fileName,
        filter: false,
      },
      {
        path: 'note',
        name: 'note',
        title: 'Примечание',
        type: columnType.TEXT,
        width: requestColumnSizes.note,
      },
      {
        path: 'managementCompanyComment',
        name: 'managementCompanyComment',
        title: 'Комментарий УК',
        width: requestColumnSizes.note,
        styles,
      },
      {
        path: ['author', 'name'],
        name: 'authorName',
        getCellValue: (row) => (row.author ? row.author.name : undefined),
        title: 'Автор',
        width: requestColumnSizes.authorName,
      },
      {
        path: 'implementationReport',
        name: 'implementationReport',
        title: 'Отчет о выполнении',
        width: requestColumnSizes.note,
        styles,
      },
      {
        path: 'requestPriority',
        name: 'requestPriority',
        title: 'Приоритет',
        getCellValue: (row) => (row.requestPriority ? row.requestPriority.name : undefined),
        width: requestColumnSizes.accessCard,
        styles,
      },
    ];
  }

  getColumnOrder() {
    return ['number', 'actualCreationDate', 'companyName', 'statusName', 'serviceName', 'whereHappened', 'whatHappened', 'assigneeName',
      'executionTerm', 'executionDate', 'fileName', 'note', 'managementCompanyComment', 'authorName', 'requestChangeDate',
      'implementationReport','requestPriority',
    ];
  }

  getActionButtons() {
    return [addActionButton, editActionButton, copyActionButton, acceptActionButton, rejectActionButton, completeActionButton,];
  }

  getActionMenuItems() {
    return [viewActionItem, editActionItem, copyActionItem, acceptActionItem, rejectActionItem, completeActionItem];
  }

  getSorting() {
    return [{ columnId: 'number', columnName: 'number', direction: 'desc' }];
  }

  getPageSize() {
    return 10;
  }

  getTableFeatures() {
    return [
      { name: settings.TABLE_ROW_DETAIL, value: this.props.roles && this.props.roles.includes(role.ADMINISTRATOR_BC) },
      { name: settings.TABLE_DRAWER, value: false },
      { name: settings.FILTERING, value: true },
      { name: settings.FILTER_BUTTON, value: true },
      { name: settings.SETTING_BUTTON, value: true },
      { name: settings.UPDATE_BUTTON, value: true },
    ];
  }

  render() {
    const { onActionExecuting, onRowDoubleClick, viewName } = this.props;
    return (
      <AdvancedDataTable
        name={SERVICE_REQUESTS_MANAGER_REQUESTS_TABLE_GRID}
        entityName="requests"
        actionButtons={this.getActionButtons()}
        actionMenuItems={this.getActionMenuItems()}
        columnOrder={this.getColumnOrder()}
        columns={this.getColumns()}
        filters={this.getFilters()}
        pageSize={this.getPageSize()}
        onActionExecuting={onActionExecuting}
        onRowDoubleClick={onRowDoubleClick}
        detailContainer={getRequestDetailContainer()}
        sorting={this.getSorting()}
        tableFeatures={this.getTableFeatures()}
        viewName={viewName}
        filePreviewFieldName="scan"
        filtering
        selectable
        tableType={settings.PAGING_TABLE}
        mode="parent"
      />
    );
  }
}

ServiceRequestsManagerDxGrid.propTypes = {
  viewName: PropTypes.string,
  onActionExecuting: PropTypes.func,
  onRowDoubleClick: PropTypes.func,
};

export default ServiceRequestsManagerDxGrid;
